<template lang="pug">
  app-layout
    v-dialog(v-model="showIsProcessingDialog" persistent width='750px')
      v-card
        title-bar(dark) GRANTING YOU ACCESS TO LIONDESK AD PORTAL
        v-card-text
          p You are seeing this message because your LionDesk account was created or re-activated in the last 8 hours.
          | We are working on getting you access to LionDesk Ad Portal. Please check back in {{ getFeedProcessRemainingHours }} hrs.
        v-card-actions
          v-spacer
          v-btn(flat @click="hideIsProcessingDialog") cancel
          v-btn.primary(@click="adsGetStartedRedirect" data-cy="submit-button") SHOW ME WHAT I CAN DO NOW
    v-flex(xs12)
      title-bar {{ title }}
      div.subtitle Choose the type of ad you want to start with
      router-link.hyperlink(:to="{ name: 'facebook-ads-get-started' }")
        v-icon(color="primary" small) keyboard_arrow_left
        span Back
      v-container(fluid)
        v-layout(row wrap)
          advertise-type-card(
            v-for="properties in adsCards"
            :properties="properties"
          )
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import AdvertiseTypeCard from './components/AdvertiseTypeCard';
import REAL_ESTATE_OWN_AD from './config/real-estate-own-ad';

export default {
  components: {
    TitleBar,
    AdvertiseTypeCard,
  },
  data() {
    return {
      adsCards: [],
      title: ''
    }
  },
  async created() {
    if (!this.user) {
      await this.getUser();
    }
    this.advertiseList();
    this.getEvocalizeUserData(this.user.id);
  },
  computed: {
    ...mapState('evocalize',['showIsProcessingDialog']),
    ...mapState('userInformation',['user']),
    ...mapGetters('evocalize', ['getFeedProcessRemainingHours'])
  },
  methods: {
    ...mapActions('evocalize',['getEvocalizeUserData']),
    ...mapActions('userInformation',['getUser']),
    ...mapMutations('evocalize', ['setShowIsProcessingDialog']),
    advertiseList() {
      const ad_type = this.$route.params.type.replace('-', '_');
      const { data, title } = REAL_ESTATE_OWN_AD[ad_type];
      this.title = title;
      this.adsCards = data;
    },
    adsGetStartedRedirect() {
      this.$router.push({ name: "pending-access" });
      this.hideIsProcessingDialog();
    },
    hideIsProcessingDialog() {
      this.setShowIsProcessingDialog(false);
    },
  },
}
</script>
<style lang="scss" scoped>
  .subtitle {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;
    color: var(--v-secondary-lighten2);
    margin-left: 58px;
    margin-bottom: 12px;
  }
  .hyperlink {
    margin-left: 48px;
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;
    .v-icon {
      vertical-align: middle;
    }
  }
</style>
